import { configureStore } from '@reduxjs/toolkit'
import automationReducer from './reducers/automationReducer'
import booksReducer from './reducers/booksReducer'
import coursesReducer from './reducers/coursesReducer'
import favouritesReducer from './reducers/favouritesReducer'
import glossaryAutomationReducer from './reducers/glossaryAutomationReducer'
import notificationReducer from './reducers/notificationReducer'
import papersReducer from './reducers/papersReducer'
import podcastsReducer from './reducers/podcastsReducer'
import policiesReducer from "./reducers/policiesReducer";
import resourcesReducer from './reducers/resourcesReducer'
import tagsReducers from './reducers/tagsReducers'
import tcairemReducer from './reducers/tcairemReducer'
import userReducer from './reducers/userReducer'
import usersReducer from './reducers/usersReducer'
import terminologyReducer from './reducers/terminologyReducer'
import revisionReducer from './reducers/revisionReducer'
import videosReducer from './reducers/videosReducer'
import codenotebooksReducer from './reducers/codenotebooksReducer'

// create store for redux
const store = configureStore({
    reducer: {
        automation: automationReducer,
        books: booksReducer,
        courses: coursesReducer,
        favourites: favouritesReducer,
        glossaryAutomation: glossaryAutomationReducer,
        notifications: notificationReducer,
        papers: papersReducer,
        policies: policiesReducer,
        podcasts: podcastsReducer,
        codenotebooks: codenotebooksReducer,
        resources: resourcesReducer,
        tags: tagsReducers,
        tcairemResources: tcairemReducer,
        terminology: terminologyReducer,
        revisions: revisionReducer,
        user: userReducer,
        users: usersReducer,
        videos: videosReducer
    }
})

export default store
